import React from 'react';
import PageHero from '@/components/PageHero';
import SEO from '@/components/SEO';
import { AWARDS } from '@/data/content';
import { Award, ShieldCheck, Star, Medal, Scale } from 'lucide-react';

const ICONS = [ShieldCheck, Medal, Award, Star, Scale];

export default function Awards() {
  return (
    <div>
      <SEO
        title="Awards & Commendations"
        description="Awards, commendations, and honors earned by Lt. Joseph M. Kress during 25+ years of decorated police service, including the Medal of Valor and Purple Heart."
        path="/awards"
      />
      <PageHero
        title="Awards & Commendations"
        subtitle="A distinguished record of service, valor, and expertise in drug law enforcement."
        image="https://images.unsplash.com/photo-1613264520739-c2eb038e8404?auto=format&fit=crop&w=1920&q=80"
        crumbs={['Awards']}
      />
      <div className="max-w-5xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 gap-6">
          {AWARDS.map((a, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={i}
                className="bg-white p-7 rounded-lg shadow-sm border border-slate-200 hover:shadow-md hover:border-amber-300 transition-all"
              >
                <div className="h-12 w-12 rounded-md bg-[#0b2545] text-amber-400 flex items-center justify-center mb-4">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="font-serif text-xl font-bold text-[#0b2545] mb-3">{a.title}</h3>
                <p className="text-slate-600 leading-relaxed text-sm">{a.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
